import { render, staticRenderFns } from "./CodeItemSimpleCard.vue?vue&type=template&id=ddb227ee&scoped=true"
import script from "./CodeItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./CodeItemSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./CodeItemSimpleCard.vue?vue&type=style&index=0&id=ddb227ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb227ee",
  null
  
)

export default component.exports